import React from "react";

export default function EmpLeaves() {
  const leaves = [
    {
      startDate: "12 Jan 2025",
      endDate: "14 Jan 2025",
      type: "Sick Leave",
      duration: "3 days",
      reason: "Fever & Rest",
      status: "Pending",
    },
    {
      startDate: "04 Jan 2025",
      endDate: "04 Jan 2025",
      type: "Casual Leave",
      duration: "1 day",
      reason: "Personal Work",
      status: "Approved",
    },
    {
      startDate: "22 Feb 2025",
      endDate: "23 Feb 2025",
      type: "Vacation",
      duration: "2 days",
      reason: "Family Trip",
      status: "Rejected",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Approved":
        return "bg-green-500 text-white";
      case "Pending":
        return "bg-yellow-400 text-gray-800";
      case "Rejected":
        return "bg-red-500 text-white";
      default:
        return "bg-gray-200 text-gray-800";
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">My Leaves</h2>

      <div className="bg-white shadow-lg rounded-2xl overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
            <tr>
              <th className="p-3 text-left">Start Date</th>
              <th className="p-3 text-left">End Date</th>
              <th className="p-3 text-left">Type</th>
              <th className="p-3 text-left">Duration</th>
              <th className="p-3 text-left">Reason</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {leaves.map((leave, idx) => (
              <tr
                key={idx}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                <td className="p-3">{leave.startDate}</td>
                <td className="p-3">{leave.endDate}</td>
                <td className="p-3 font-medium">{leave.type}</td>
                <td className="p-3">{leave.duration}</td>
                <td className="p-3">{leave.reason}</td>
                <td className="p-3">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                      leave.status
                    )}`}
                  >
                    {leave.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
